import { MonthlyEventType } from 'src/shared/components';
import { LanguageEnums, NotificationFlagsEnums, SortDirectionEnums } from 'src/shared/enums';

export interface IMapperRecord<T> {
  [key: string]: T;
}

export const mapLanguageIdEnums: IMapperRecord<string> = {
  [LanguageEnums.EN]: 'en-US',
  [LanguageEnums.FR]: 'fr-FR',
  [LanguageEnums.ES]: 'es-ES',
};

export const mapAbsenceStatusStyle: IMapperRecord<MonthlyEventType['type']> = {
  [NotificationFlagsEnums.INITIAL]: 'warning',
  [NotificationFlagsEnums.ACCEPTED]: 'success',
  [NotificationFlagsEnums.REJECTED]: 'error',
  [NotificationFlagsEnums.CANCELLED]: 'default',
};

export const mapTimecardCategoryLightColors: string[] = [
  '#305097', // primary.900
  '#427FC9', // primary.700
  '#63ADED', // primary.400
  '#9DCFF5', // primary.200
  '#374E62', // accent.800
  '#55758F', // accent.600
  '#7A97B1', // accent.400
  '#AEC3D7', // accent.200
  '#2C384A', // text.800
  '#5E697E', // text.600
  '#A6B2C8', // text.400
];

export const mapTimecardCategoryDarkColors: string[] = [
  '#427FC9', // primary.700
  '#63ADED', // primary.400
  '#9DCFF5', // primary.200
  '#E6F3FC', // primary.50
  '#6384A1', // accent.500
  '#90AAC2', // accent.300
  '#C9DCEC', // accent.100
  '#8691A7', // text.500
  '#CAD6ED', // text.300
  '#E5F1FF', // text.100
  '#E6F1FF', // accent.50
];

export const mapHorizontalBarLightColors: string[] = [
  '#305097', // primary.900
  '#427FC9', // primary.700
  '#63ADED', // primary.400
];

export const mapHorizontalBarDarkColors: string[] = [
  '#305097', // primary.900
  '#427FC9', // primary.700
  '#63ADED', // primary.400
];

export const mapSortDirectionEnums: IMapperRecord<'asc' | 'desc'> = {
  [SortDirectionEnums.ASCENDING]: 'asc',
  [SortDirectionEnums.DESCENDING]: 'desc',
};
